import { toast as sonnerToast } from 'sonner';
import { Toast, ToastProps } from './Toast';

function _toast(toast: Omit<ToastProps, 'id'>) {
  return sonnerToast.custom(() => <Toast {...toast} />);
}
export function success(toast: Omit<ToastProps, 'id' | 'type'>) {
  return _toast({ ...toast, type: 'success' });
}

export function error(toast: Omit<ToastProps, 'id' | 'type'>) {
  return _toast({ ...toast, type: 'fail' });
}

export function loading(toast: Omit<ToastProps, 'id' | 'type'>) {
  return _toast({ ...toast, type: 'loading' });
}

export function toast(toast: Omit<ToastProps, 'id' | 'type'>) {
  return _toast(toast);
}
